import { z } from "zod";

// ── Sign-up form schema ─────────────────────────────────────────

export const signupSchema = z.object({
  name: z
    .string()
    .min(2, "Name must be at least 2 characters")
    .max(100, "Name must be at most 100 characters"),
  email: z.string().email("Please enter a valid email address"),
  password: z
    .string()
    .min(8, "Password must be at least 8 characters")
    .regex(/\d/, "Password must contain at least one number"),
});

export type SignupFormValues = z.infer<typeof signupSchema>;

// ── Login form schema ───────────────────────────────────────────

export const loginSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(1, "Password is required"),
  rememberMe: z.boolean(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;

// ── Request reset password schema ──────────────────────────────

export const requestResetSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
});

export type RequestResetFormValues = z.infer<typeof requestResetSchema>;

// ── Set new password schema ─────────────────────────────────────

export const setNewPasswordSchema = z
  .object({
    newPassword: z
      .string()
      .min(8, "Password must be at least 8 characters")
      .regex(/\d/, "Password must contain at least one number"),
    confirmPassword: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export type SetNewPasswordFormValues = z.infer<typeof setNewPasswordSchema>;

// ── Role selection schema ───────────────────────────────────────

export const roleSelectSchema = z.object({
  role: z.enum(["producer", "vendor"]),
});

export type RoleSelectFormValues = z.infer<typeof roleSelectSchema>;
